import React, {useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import DashboardDeliveriesContent from './dashboard-deliveries-content'
import { setActivePage } from '../../../redux/actions/active-page'

const Index = props => {

	const dispatch = useDispatch()
	const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)

	useEffect(() => {
		dispatch(setActivePage("deliveries"))
	})


	useEffect(() => {
		
		if(activeCompany && !activeCompany.subscription){
			props.history.push('/dashboard/oversikt')
			dispatch(setActivePage("overview"))
		}
	}, [activeCompany])

	return(
		<DashboardDeliveriesContent/>
	)
}

export default withRouter(Index)



